import Vue from 'vue'
import Vuex from 'vuex'
import { userApi } from '@/modules/chemical/api'
import { setTokenCache } from '@/utils/request'
import { myApi } from '@/modules/waste/api'
import { getOfficeIdFromStorage } from '@/modules/waste/utils/officeType'

Vue.use(Vuex)

// 单位类型（产生单位=隐藏台账下的接收入库/联单接受/利用处置/联单核准/联单接收入库）
// 登录后由 Login.vue 触发 fetchOfficeType 拉取并存到 localStorage
function readCachedType() {
  try {
    return localStorage.getItem('officeType') || ''
  } catch (e) {
    return ''
  }
}

export default new Vuex.Store({
  state: {
    // 全局 Token
    token: localStorage.getItem('token') || '',
    // 单位类型，如 'QYSX_CF'（产生单位）
    officeType: readCachedType(),
    // officeType 是否已加载过（避免重复请求）
    officeTypeLoaded: !!readCachedType()
  },
  mutations: {
    // Token 相关
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
      // 同步更新缓存中的token
      setTokenCache(token)
    },
    LOGOUT(state) {
      state.token = ''
      localStorage.removeItem('token')
      // 清除缓存中的token
      setTokenCache(null)
    },
    // 单位类型相关
    SET_OFFICE_TYPE(state, type) {
      state.officeType = type || ''
      try {
        if (type) {
          localStorage.setItem('officeType', type)
        } else {
          localStorage.removeItem('officeType')
        }
      } catch (e) {
        console.error('officeType 本地存储失败', e)
      }
    },
    SET_OFFICE_TYPE_LOADED(state, loaded) {
      state.officeTypeLoaded = !!loaded
    }
  },
  actions: {
    // ====== Chemical (危化品) 相关 Actions ======
    async login({ commit }, userInfo) {
      try {
        const response = await userApi.login(userInfo)
        if (response.code === 200 || response.code === "0000") {
          const token = response.data?.token || response.token
          commit('SET_TOKEN', token)
          return response
        } else {
          throw new Error(response.message || '登录失败')
        }
      } catch (error) {
        console.error('登录接口调用失败:', error)
        throw error
      }
    },
    async register(context, userInfo) {
      try {
        const response = await userApi.register(userInfo)
        if (response.code === 200 || response.code === "0000") {
          return response
        } else {
          throw new Error(response.message || '注册失败')
        }
      } catch (error) {
        console.error('注册接口调用失败:', error)
        throw error
      }
    },
    logout({ commit }) {
      commit('LOGOUT')
    },

    // ====== Waste (危废) 相关 Actions ======
    // 从 localStorage.user / token 中解出 officeId，调用 /sys/office/{id}，把 result.type 写入 store
    async fetchOfficeType({ commit, state }, { force } = {}) {
      // 已加载过且非强制刷新：跳过
      if (state.officeTypeLoaded && !force) return
      const officeId = getOfficeIdFromStorage()
      if (!officeId) return
      try {
        const res = await myApi.officeData(officeId)
        const type = (res && res.result && res.result.type) || ''
        commit('SET_OFFICE_TYPE', type)
        commit('SET_OFFICE_TYPE_LOADED', true)
      } catch (e) {
        console.error('获取单位类型失败', e)
        // 失败也标记为已加载，避免每个组件都重试
        commit('SET_OFFICE_TYPE_LOADED', true)
      }
    }
  }
})